import moment from 'moment';
import momentTz, { Moment } from 'moment-timezone';

moment.updateLocale('en', {
  relativeTime: {
    m: '1 minute',
    h: '1 hour',
    d: '1 day',
    w: '1 week',
    M: '1 month',
    y: '1 year',
  },
});

export const DATE_FORMATS = {
  dddd_MMMM_D: 'dddd, MMMM D',
  DD_MMM_YYYY: 'DD-MMM-YYYY',
  M_D_YYYY: 'M/D/YYYY',
  M_D_YYYY_V2: 'M-D-YYYY',
  YYYY_MM_DD_SLASH: 'YYYY/MM/DD',
  MM_DD_YY: 'MM-DD-YY',
  MM_DD_YYYY: 'MM/DD/YYYY',
  MM_DD_YYYY_V2: 'MM-DD-YYYY',
  MMMM_YYYY: 'MMMM YYYY',
  MMM_D: 'MMM D',
  MMM_DO: 'MMM Do',
  UTC_DATE_TIME: 'YYYY-MM-DDTHH:mm:ss.SSSZ', // as presented by the patient-adherence api
  UTC_DATE_TIME_SHORT: 'YYYY-MM-DDTHH:mm:ssZ',
  UTC_DATE: 'YYYY-MM-DD',
  YYYY_MM_DD: 'YYYY-MM-DD', // patient adherence birthday format from api
};

export const DEFAULT_TIMEZONE = 'America/New_York';

export const restrictTimezone = (timezone: string | null | undefined) => {
  // Restrict invalid timezone returned from APIs
  const invalidTimezone = 'America/NewYork';
  const validTimezone =
    timezone === invalidTimezone ? 'America/New_York' : timezone;
  return validTimezone || DEFAULT_TIMEZONE;
};

export const formatDate = (
  date: number | string | Moment | null | undefined,
  format?: string | null,
): string => (date ? moment(date).format(format || DATE_FORMATS.M_D_YYYY) : '');

export const formatDateWithGivenFormat = (
  date: string,
  format: string,
  newFormat: string,
) => moment(date, format).format(newFormat);

export const formatDateWithTimezone = (
  date: string | Record<string, any> | number | null | undefined,
  timezone: string | null | undefined,
  format?: string | null,
): string => {
  const validTimezone = restrictTimezone(timezone);
  return date
    ? momentTz(date)
        .tz(validTimezone)
        .format(format || DATE_FORMATS.M_D_YYYY)
    : '';
};

export const displayDateTimeFromNow = (dateTimeWithTimezone: string) =>
  moment(dateTimeWithTimezone).fromNow();
export const isValidDateFormat = (date: string, format: string) =>
  moment(date, format, true).isValid();
